/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Radio } from '@thd-olt-component-react/checkbox';
import '../../styles/refinement.scss';

const CpoDimension = ({
  collapsed,
  cpoData,
  drawer,
  onChange
}) => {
  const { cpoOnly } = cpoData;
  const [selected, setSelectedItem] = useState(cpoOnly ? 'cpoOnly' : null);
  const radioClassName = 'radio';
  const label = 'Custom Catalog';
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  const wrapperClassName = classNames({
    'dimension--collapsed': collapsed
  });

  const dimensionLabelClassName = classNames('dimension__label', {
    'dimension__label--padding': !drawer
  });

  const handleOnChange = (event) => {
    const isCpoOnly = event.target.value === 'cpoOnly';

    setSelectedItem(event.target.value);

    if (onChange) {
      onChange(isCpoOnly);
    }
  };

  const handleCollapse = (event) => {
    event.preventDefault();
    setIsCollapsed(!isCollapsed);
  };

  const borderClassName = classNames('dimension__box', {
    'dimension__box--line': drawer && !isCollapsed
  });

  const shadowClassName = classNames({ 'dimension__box--shadow': drawer });

  return (
    <div className="dimension">
      <Row className={shadowClassName}>
        <Row>
          <a className={borderClassName} href="#" onClick={handleCollapse}>
            <Col fallback="9">
              <h2 className={dimensionLabelClassName} data-group={label}>{label}</h2>
            </Col>
            <Col fallback="3" className="dimension__caret--align">
              <img
                className={isCollapsed ? 'dimension__caret--collapsed' : 'dimension__caret'}
                alt="caret-icon"
                src="https://assets.thdstatic.com/images/v1/caret-grey.svg"
                height="15"
                width="9"
              />
            </Col>
          </a>
        </Row>
        <Row className={wrapperClassName}>
          <Radio.Group>
            <Radio
              className={classNames(radioClassName)}
              id="cpoOnly"
              checked={selected === 'cpoOnly'}
              isChecked={selected === 'cpoOnly'}
              name="cpoData"
              type="radio"
              data-refinement="isCpoOnly"
              data-refinementvalue="true"
              data-active="yes"
              data-omni="true"
              onChange={handleOnChange}
              value="cpoOnly"
            >
              Custom Catalog
            </Radio>
            <Radio
              className={classNames(radioClassName)}
              id="totalCount"
              checked={selected === 'totalCount'}
              isChecked={selected === 'totalCount'}
              name="cpoData"
              type="radio"
              data-refinement="isCpoOnly"
              data-refinementvalue="false"
              data-active="yes"
              data-omni="true"
              onChange={handleOnChange}
              value="totalCount"
            >
              All items
            </Radio>
          </Radio.Group>
        </Row>
      </Row>
    </div>
  );
};

CpoDimension.propTypes = {
  cpoData: PropTypes.shape({
    cpoCount: PropTypes.string,
    cpoOnly: PropTypes.bool.isRequired,
    totalCount: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  drawer: PropTypes.bool,
  collapsed: PropTypes.bool,
};

CpoDimension.defaultProps = {
  drawer: false,
  collapsed: false
};

CpoDimension.displayName = 'CpoDimension';

export { CpoDimension };
